"use client";

import { useEffect, useState } from "react";

/** Tailwind's `md` breakpoint — the width at which the editor chrome fits. */
const MOBILE_QUERY = "(max-width: 767px)";

/**
 * Tracks whether the viewport is below Tailwind's `md` breakpoint.
 *
 * Returns `null` until the first client render so callers can tell "not yet
 * known" from "known to be desktop". That matters for the view-mode and
 * sidebar defaults: resolving to `false` during SSR/first paint would mount the
 * editable chrome on a phone and then tear it down, and the user would see the
 * toolbar flash before it disappeared.
 */
export function useIsMobile(): boolean | null {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const update = () => setIsMobile(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);

  return isMobile;
}
